<template>
    <div>
        <div class="panel">
            <h2>Gestor Board Login</h2>
            <p>Entre com seu login e senha</p>
        </div>
        <div class="container" >        
            <div class="alert alert-warning" role="alert" v-show="ErrorShow == true" >
                <small>{{ErrorMensage}}</small>
            </div>
        </div>
        <form id="Login" >
            <div class="form-group">
                <input type="text" class="form-control" v-model="User" placeholder="Login">
            </div>
            <div class="form-group">
                <input type="password" class="form-control" v-model="Pass" placeholder="Senha">
            </div>
            <div class="form-group">
                <input class="form-check-input" type="checkbox" name="remember" id="remember" >
                <label class="form-check-label" for="remember">
                    Permanecer logado?
                </label>
            </div>
            <div class="forgot">
                <a href="" >Esqueceu a senha?</a>
            </div>
            <a href="#" @click.prevent="userLogin" class="btn btn-primary">Login</a>
        </form>
    </div>    
</template>
<script>
// import {mapState, mapGetters, mapMutations} from 'vuex'
export default {
    name: 'vwLogin',
    data(){
        return {
            User            : '',
            Pass            : '',
            ErrorMensage    : '',
            ErrorShow       : false
        }
    },
    computed: {
        logged(){
            return this.$store.state.logged
        }
    },
    methods: {
        // ...mapMutations('store/index', ['login']),
        userLogin: function(){
            if(this.User.length == 0 || this.Pass.length == 0){
                this.ErrorShow      = true
                this.ErrorMensage   = 'Existem campos vazios ou inválidos.'
            }else{
                this.$store.dispatch('LOGIN', {
                    info: {
                        user: this.User,
                        pass: this.Pass
                    },
                    vm: this
                })
                    .then(response => {
                        if(response.status = true){
                            this.$router.push({
                                name: 'home'
                            })
                        }else{
                            this.ErrorShow = true
                            this.ErrorMensage = response.data
                        }
                    }, error => {
                        this.ErrorShow = true
                        this.ErrorMensage = error.data
                    })

            }
        }
    }
}
</script>
<style scoped>
	.form-group {
		margin-bottom:10px;
	}
	.panel h2{ 
		color:#444444; 
		font-size:18px; 
		margin:0 0 8px 0;
	}
	.panel p { 
		color:#777777; 
		font-size:14px; 
		margin-bottom:30px; 
		line-height:24px;
	}
	.forgot a {
		color: #777777;
		font-size: 14px;
		text-decoration: underline;
	}
	.btn.btn-primary {
		background: #f0ad4e none repeat scroll 0 0;
		border-color: #f0ad4e;
		color: #ffffff;
		font-size: 14px;
		width: 100%;
		height: 50px;
		line-height: 50px;
		padding: 0;
	}
	.forgot {
		text-align: left; 
		margin-bottom:30px;
	}
	.btn.btn-primary.reset {
		background: #ff9900 none repeat scroll 0 0;
	}
	.back { 
		text-align: left; 
		margin-top:10px;
	}
	.back a {
		color: #444444; 
		font-size: 13px;
		text-decoration: none;
	}
</style>